module.exports = __webpack_public_path__ + "img/guide2.06d94387.png";